export const FETCH_OFFERS = 'offer/FETCH_OFFERS'
export const FETCH_OFFERS_SUCCESS = 'offer/FETCH_OFFERS_SUCCESS'
export const FETCH_OFFERS_FAILURE = 'offer/FETCH_OFFERS_FAILURE'
export const RESET_OFFERS = 'offer/RESET_OFFERS'

export const FETCH_OFFER = 'offer/FETCH_OFFER'
export const FETCH_OFFER_SUCCESS = 'offer/FETCH_OFFER_SUCCESS'
export const FETCH_OFFER_FAILURE = 'offer/FETCH_OFFER_FAILURE'
export const RESET_OFFER = 'offer/RESET_OFFER'

export const CREATE_OFFER = 'offer/CREATE_OFFER'
export const CREATE_OFFER_SUCCESS = 'offer/CREATE_OFFER_SUCCESS'
export const CREATE_OFFER_FAILURE = 'offer/CREATE_OFFER_FAILURE'
export const RESET_CREATE_OFFER = 'offer/RESET_CREATE_OFFER'

export const UPLOAD_IMAGE_OFFER = 'offer/UPLOAD_IMAGE_OFFER'
export const UPLOAD_IMAGE_OFFER_SUCCESS = 'offer/UPLOAD_IMAGE_OFFER_SUCCESS'
export const UPLOAD_IMAGE_OFFER_FAILURE = 'offer/UPLOAD_IMAGE_OFFER_FAILURE'

export const DELETE_IMAGE_OFFER = 'offer/DELETE_IMAGE_OFFER'
export const DELETE_IMAGE_OFFER_SUCCESS = 'offer/DELETE_IMAGE_OFFER_SUCCESS'
export const DELETE_IMAGE_OFFER_FAILURE = 'offer/DELETE_IMAGE_OFFER_FAILURE'
export const RESET_DELETE_IMAGE_OFFER = 'offer/RESET_DELETE_IMAGE_OFFER'

export const UPDATE_OFFER = 'offer/UPDATE_OFFER'
export const UPDATE_OFFER_SUCCESS = 'offer/UPDATE_OFFER_SUCCESS'
export const UPDATE_OFFER_FAILURE = 'offer/UPDATE_OFFER_FAILURE'
export const RESET_UPDATE_OFFER = 'offer/RESET_UPDATE_OFFER'

export const DELETE_OFFER = 'offer/DELETE_OFFER'
export const DELETE_OFFER_SUCCESS = 'offer/DELETE_OFFER_SUCCESS'
export const DELETE_OFFER_FAILURE = 'offer/DELETE_OFFER_FAILURE'
export const RESET_DELETE_OFFER = 'offer/RESET_DELETE_OFFER'


// WEBPACK FOOTER //
// ./src/store/offer/actionTypes.js